import React from 'react'
import {
  Box,
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material'
import { format } from 'date-fns'
import { ContractTimelineItem } from '@/services/contractsService'

interface ContractTimelineProps {
  timeline: ContractTimelineItem[]
  loading?: boolean
}

const ContractTimeline: React.FC<ContractTimelineProps> = ({
  timeline,
  loading = false,
}) => {
  if (loading) {
    return (
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Contract Timeline
          </Typography>
          <Box display="flex" justifyContent="center" py={4}>
            <Typography variant="body2" color="text.secondary">
              Loading timeline...
            </Typography>
          </Box>
        </CardContent>
      </Card>
    )
  }

  if (!timeline || timeline.length === 0) {
    return (
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Contract Timeline
          </Typography>
          <Box display="flex" justifyContent="center" py={4}>
            <Typography variant="body2" color="text.secondary">
              No timeline events available
            </Typography>
          </Box>
        </CardContent>
      </Card>
    )
  }

  // Sort timeline by createdAt descending (most recent first)
  const sortedTimeline = [...timeline].sort(
    (a, b) =>
      new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  )

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Contract Timeline
        </Typography>
        <List sx={{ position: 'relative', pl: 0 }}>
          {sortedTimeline.map((item, index) => (
            <ListItem
              key={item._id}
              sx={{
                position: 'relative',
                pl: 5,
                pb: index < sortedTimeline.length - 1 ? 2 : 0,
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  left: '15px',
                  top: '36px',
                  bottom: '-16px',
                  width: '2px',
                  backgroundColor: 'divider',
                  display: index === sortedTimeline.length - 1 ? 'none' : 'block',
                },
              }}
            >
              <ListItemIcon
                sx={{
                  position: 'absolute',
                  left: 0,
                  minWidth: 'auto',
                  color: 'success.main',
                }}
              >
                <CheckCircleIcon />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography variant="body2" fontWeight={500}>
                    {item.title}
                  </Typography>
                }
                secondary={
                  <Typography variant="caption" color="text.secondary">
                    {item.createdAt &&
                      !isNaN(new Date(item.createdAt).getTime())
                      ? format(new Date(item.createdAt), 'MM/dd/yyyy hh:mm a')
                      : '--'}
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  )
}

export default ContractTimeline

